// extracted by css-extract-rspack-plugin
export default {"openInFullPageLink":"YSiBeFw___s4hPHV","shareLinkButton":"CRbNf5UW_HwNL9sY"};